import Layout from "components/Layout";
import React from "react";
import DeviceAddForm from "./components/DeviceAddForm";

function AdminDeviceAddPage() {
  return (
    <Layout title="장치 등록">
      <DeviceAddForm />
    </Layout>
  );
}

export default AdminDeviceAddPage;
